<template>
    <div class="btn-group" id="search-group">
        <input v-model="value" v-on:keyup="setSearch" id="search-input" type="text" class="form-control" placeholder="Search ...">
        <span v-if="value" class="glyphicon glyphicon-remove-circle" id="search-clear" @click="removeSearch"></span>
		<span class="glyphicon glyphicon-search" id="search-icon"></span>
    </div>
</template>

<style scoped>
    #search-group {
		 width: -webkit-fill-available;
	}
	#search-input {
		padding-right: 52px;
		border-radius: 4px;
	}
	#search-clear {
		position: absolute;
		right: 32px;
		top: 0;
		bottom: 0;
		height: 16px;
		margin: auto;
		font-size: 16px;
		cursor: pointer;
		color: red;
	}
	#search-icon {
		position: absolute;
		right: 6px;
		top: 0;
		bottom: 0;
		height: 16px;
		margin: auto;
		font-size: 16px;
		cursor: pointer;
		color: #9d9d9d;
	}
</style>
<script>
export default {
    props: {
        initialValue: {
			type: String,
			required: true,
        },
        onClear: {
			type: Function,
			required: true,
		},
	},
	mounted() {
		this.value = this.initialValue
	},
    data() {
        return {
			delayTimer: null,
			value: '',
        }
    },
    methods: {
        setSearch: function(e) {
			if(e.key == 'Enter') {
				this.onClear(this.value);
				clearTimeout(this.delayTimer);
				return ;
			}

			if(this.delayTimer) {
				clearTimeout(this.delayTimer);
			}

			this.delayTimer = setTimeout(() => {
				this.onClear(this.value);
			}, 1500);
		},
		removeSearch: function(e) {
			this.value = '';
			this.onClear(this.value);
		},
    }
}
</script>